import { PropsWithChildren, ReactNode, useMemo, cloneElement } from 'react';
import { components, DropdownIndicatorProps, GroupBase } from 'react-select';
import { ReactComponent as SearchIcon } from 'assets/search_icon.svg';
import { ReactComponent as ChevronIcon } from 'assets/chevron_icon.svg';
import styles from './select.module.scss';

export function getDropdownIndicator<T>(
  props: PropsWithChildren<DropdownIndicatorProps<T, boolean, GroupBase<T>>>,
  isSearchSelect: boolean,
  customIcon?: ReactNode
): JSX.Element | null {
  if (props.isDisabled) return null;
  const icon = useMemo(() => {
    const className = `${styles.dropdownIcon} ${props.isFocused && styles.focused}`;
    if (customIcon && typeof customIcon === 'object') {
      // Clone the customIcon element and add className
      return cloneElement(customIcon as React.ReactElement, {
        className: `${styles.dropdownIcon} ${props.isFocused && styles.focused}`,
      });
    }
    return isSearchSelect ? <SearchIcon className={className} /> : <ChevronIcon className={className} />;
  }, [isSearchSelect, customIcon, props.isFocused]);
  return <components.DropdownIndicator {...props}>{icon}</components.DropdownIndicator>;
}
